var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.334,
    height: 21.554,
    viewBox: "0 0 28.334 21.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_777",
    "data-name": 777,
    transform: "translate(0 -61.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4830",
    "data-name": "Group 4830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4442",
    "data-name": "Group 4442",
    transform: "translate(0 61.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    "data-name": "Path 3088",
    d: "M23.907,82.813H4.427A4.432,4.432,0,0,1,0,78.386v-12.7a4.432,4.432,0,0,1,4.427-4.427h19.48a4.432,4.432,0,0,1,4.427,4.427v7.166a1.107,1.107,0,1,1-2.214,0V65.686a2.216,2.216,0,0,0-2.214-2.214H4.427a2.216,2.216,0,0,0-2.214,2.214v12.7A2.216,2.216,0,0,0,4.427,80.6h19.48a2.216,2.216,0,0,0,2.214-2.214,1.107,1.107,0,0,1,1.107-1.107h0a1.107,1.107,0,0,1,1.107,1.107A4.432,4.432,0,0,1,23.907,82.813Z",
    transform: "translate(0 -61.259)",
    fill: "#efc04b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4446",
    "data-name": "Group 4446",
    transform: "translate(4.517 67.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4443",
    "data-name": "Group 4443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    d: "M83.428,186.689a1.107,1.107,0,0,1-1.013-1.552l2.136-4.86H82.72a1.107,1.107,0,1,1,0-2.214h3.528a1.107,1.107,0,0,1,1.013,1.552l-2.819,6.412A1.107,1.107,0,0,1,83.428,186.689Z",
    transform: "translate(-81.613 -178.063)",
    fill: "#efc04b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4444",
    "data-name": "Group 4444",
    transform: "translate(6.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M205.942,186.689a1.107,1.107,0,0,1-1.013-1.552l2.137-4.86h-1.832a1.107,1.107,0,0,1,0-2.214h3.528a1.107,1.107,0,0,1,1.013,1.552l-2.819,6.413A1.107,1.107,0,0,1,205.942,186.689Z",
    transform: "translate(-204.127 -178.063)",
    fill: "#efc04b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4445",
    "data-name": "Group 4445",
    transform: "translate(13.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M328.457,186.689a1.107,1.107,0,0,1-1.013-1.552l2.137-4.86h-1.832a1.107,1.107,0,0,1,0-2.214h3.528a1.107,1.107,0,0,1,1.013,1.552l-2.819,6.413A1.107,1.107,0,0,1,328.457,186.689Z",
    transform: "translate(-326.642 -178.063)",
    fill: "#efc04b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots);
export default __webpack_public_path__ + "static/media/slots.28649e5d515134205b7c3db821e0341e.svg";
export { ForwardRef as ReactComponent };